export const PAYMENT_OPTIONS = {
  contraentrega: 0,
  payku_webpay: 1,
  payku_khipu: 2,
  payku_multicaja_efectivo: 3,
  payku_multicaja_transferencia: 4,
  payku_onepay: 5,
  payku_pago46: 6,
  payku_sweetpay: 7,
  transferencia: 10
};

export const DELIVERY_OPTIONS = {
  none: "none",
  delivery: "delivery",
  convenience: "convenience",
  pickup: "pickup"
};

export const CART_STATUS = {
  pending: "pendiente",
  onPayment: "en pago",
  finished: "finalizado",
  canceled: "cancelado"
};

export const ORDER_STATUS = {
  paymentPending: 0,
  inbox: 1,
  packing: 2
};

export const TEMPLATES = {
  default: "default",
  ecommerce: "ecommerce"
};

export const MAX_SIGNV4_OFFSET = 300000;
